import axios from 'axios';
const API_URL = process.env.REACT_APP_API_ENDPOINT;

export const get_customer_overview = async (values) => {
    const res = await axios.post(`${API_URL}common/customer-overview`, values);
    return res;
};

export const get_customer_overview_per_dau = async (values) => {
    const res = await axios.post(`${API_URL}common/customer-overview-per-dau`, values);
    return res;
};
